// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: var(--text);
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

:root {
  --primary: hsla(180, 45%, 34%, 0.9);
  --primary-hover: hsla(180, 45%, 34%, 1);
  --primary-light: hsla(180, 60%, 70%, 0.3);

  --bg-dark: hsl(336 0% 1%);
  --bg: hsl(300 0% 4%);
  --bg-light: hsl(0 0% 9%);
  --text: hsl(300 0% 95%);
  --text-muted: hsl(300 0% 69%);
  --highlight: hsla(330, 0%, 39%, 0.9);
  --highlight-hover: hsl(330 0% 39%);
  --border: hsl(0 0% 28%);
  --border-muted: hsl(300 0% 18%);

  --gradient: linear-gradient(0deg, var(--bg) 95%, var(--bg-light));
  --gradient-hover: linear-gradient(0deg, var(--bg), var(--bg-light));
  --shadow: 0px 2px 2px hsla(0, 0%, 0%, 0.07), 0px 4px 4px hsla(0, 0%, 0%, 0.15);

  --secondary: hsl(358 66% 75%);
  --danger: hsl(9 26% 64%);
  --warning: hsl(52 19% 57%);
  --success: hsl(146 17% 59%);
  --info: hsl(217 28% 65%);
}

svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--text);
}

body {
  display: grid;
  grid-template-columns: 270px 1fr;
  grid-template-rows: auto 1fr;
  width: 100vw;
  height: 100vh;
  background-color: var(--bg-light);
  transition: grid-template-columns 0.3s ease;
}

body.collapsed {
  grid-template-columns: 0 1fr;
}

#header {
  grid-column: 1 / -1;
  grid-row: 1;
  display: flex;
  align-items: center;
  background-color: var(--primary);
  padding: 1rem 2rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.sidebar-toggle {
  width: 2rem;
  height: 2rem;
  padding: 0.25rem;
  margin-right: 1rem;
  border-radius: 4px;
  stroke: var(--text) !important;
}

.sidebar-toggle:hover {
  background-color: var(--primary-light);
  cursor: pointer;
}

.header-inner {
  width: 100%;
}

.sidebar {
  grid-row: 2;
  background-color: var(--bg-dark);
  display: flex;
  flex-direction: column;
  gap: 5rem;
  width: 270px;
  min-width: 0;
  padding: 1rem;
  transition: transform 0.3s ease;
}

.sidebar.open {
  transform: translateX(0%);
}

.sidebar.collapsed {
  transform: translateX(-100%);
}

.sidebar-list {
  display: flex;
  flex-direction: column;
}

.sidebar-item {
  padding: 0.35rem 0.5rem;
}

.sidebar-item:hover {
  background-color: var(--border-muted);
  border-radius: 4px;
  cursor: pointer;
}

.sidebar-item.active {
  background-color: var(--primary-light);
  border-radius: 4px;
  cursor: pointer;
}

.sidebar-item--header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.project-item {
  padding-right: 1.25rem;
  padding-left: 2.15rem;
  display: flex;
  justify-content: space-between;
}

.project-details {
  opacity: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.project-item:hover .project-details {
  opacity: 1;
}

.project-item svg {
  width: 1.5rem;
  height: 1.5rem;
  padding: 2px;
  border-radius: 4px;
}

.project-item svg:hover {
  fill: var(--border);
  background-color: var(--text);
}

.project-item span {
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sidebar-link--bar {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.sidebar-link--bar span {
  white-space: nowrap;
}

.sidebar-link--bar svg {
  width: 1.5rem;
  height: 1.5rem;
  padding: 2px;
  border-radius: 4px;
  opacity: 0;
}

.sidebar-link--bar:hover svg {
  opacity: 1;
}

.sidebar-link--bar svg:hover {
  fill: var(--border);
  background-color: var(--text);
}

@media (max-width: 768px) {
  body {
    grid-template-columns: 0 1fr;
  }

  .sidebar {
    transform: translateX(-100%);
  }
}

.main-content {
  grid-row: 2;
  display: flex;
  justify-content: center;
  min-width: 0;
  padding-top: 3rem;
}

/* .main-content centers, so to prevent view from shrinking before space around
  collapses, set width 100% and make a max width. This protects the content until
  all the surrounding space is 0 */
.view {
  width: 100%;
  min-width: 0;
  height: 100%;
  max-width: 900px;
  padding: 3rem;
}

.view-header {
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  min-width: 0;
  background-color: transparent;
  padding: 0;
}

.view-title {
  max-width: 100%;
  flex-shrink: 1;
  margin: 0;
  line-height: 1.2;
  font-size: 2rem;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.view-meta {
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 0.5rem;
  margin: 0;
  font-size: 1rem;
}

.view-meta svg {
  fill: var(--text-muted);
}

.view-meta-tasks {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem;
}

.view-meta-tasks > * {
  margin: 0;
  line-height: 1;

  color: var(--text-muted);
  font-weight: 500;
}

.view-add-tasks:hover {
  color: var(--text);
  cursor: pointer;
}

.tasks-container {
  width: 100%;
  max-width: 900px;
  padding-top: 2rem;
}

.task-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5rem;
  border-bottom: 1px solid var(--highlight);
  cursor: pointer;
}

.task-item:hover {
  background-color: var(--border-muted);
  transition: 0.3s ease;
}

.task-checkbox {
  align-self: flex-start;
  width: 1rem;
  height: 1rem;
  margin-top: 0.25rem;
  background-color: transparent;
  border: 2px solid var(--text);
  border-radius: 50%;
  cursor: pointer;
}

.task-checkbox.complete {
  background-color: green;
}

.task-item-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}

.task-text > * {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding-left: 1rem;
}

.task-title {
  -webkit-line-clamp: 1;
}

.task-description {
  color: var(--text-muted);
  font-size: 0.8rem;
}

.task-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

@media (max-width: 425px) {
  .task-details {
    display: none;
  }
}

dialog {
  position: fixed;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 500px;
  background: var(--gradient);
  padding: 1rem;
  margin: 0;
  border: 1px solid var(--border);
  border-top: 1px solid var(--highlight);
  border-radius: 6px;
  box-shadow: inset 0 1px 0 var(--highlight), var(--shadow);
  z-index: 1;
  overflow: visible;
}

dialog:hover {
  background: var(--gradient);
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

.form-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
}

.form-container input {
  background: transparent;
  padding: 0.25rem 0.25rem 0.5rem 0.25rem;
  border: none;
  border-bottom: 1px solid var(--highlight);
  outline: none;
}

.form-title {
  font-size: 1.25rem;
  font-weight: 600;
}

.form-title::placeholder {
  color: var(--text-muted);
}

.form-title.invalid {
  border-bottom: 1px solid var(--secondary);
}

.error-box {
  padding: 0.25rem;
  color: var(--secondary);
  font-size: 0.7rem;
  opacity: 0;
  transition: 0.2s ease;
}

.form-description {
  padding-bottom: 0.35rem;
  margin: 0.75rem 0 1.5rem 0;
  border-bottom: 1px solid var(--highlight);
  color: var(--text-muted);
  font-size: 0.75rem;
}

.form-description::placeholder {
  color: var(--text-muted);
  font-size: 0.75rem;
}

.form-details {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.dropdown {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  position: relative;
  cursor: pointer;
}

.dropdown-select {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 115px;
  padding: 0.25rem 0.5rem;
  background-color: var(--bg-light);
  border: 1px solid var(--highlight);
  border-radius: 4px;
  font-size: 0.75rem;
}

.dropdown-select:hover {
  background-color: var(--border-muted);
  cursor: pointer;
}

.dropdown-list {
  position: absolute;
  top: 110%;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: var(--bg-light);
  border: 1px solid var(--border-muted);
  border-radius: 4px;
  font-size: 0.75rem;
}

.dropdown-option {
  width: 100%;
  padding: 0.25rem 0.5rem;
  text-align: center;
}

.dropdown-option:hover {
  background-color: var(--border-muted);
}

.dropdown-option:first-child:hover {
  border-radius: 3px 3px 0px 0px;
}

.dropdown-option:last-child:hover {
  border-radius: 0px 0px 3px 3px;
}

.form-submit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
}

.form-submit span {
  padding: 0.25rem;
  color: var(--secondary);
  font-size: 0.75rem;
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.cancel {
  background-color: var(--highlight);
  padding: 0.5rem 0.75rem;
  border: none;
  border-radius: 4px;

  color: var(--text);
  font-weight: 600;
  cursor: pointer;
}

.cancel:hover {
  background-color: var(--highlight-hover);
}

.add {
  background-color: var(--primary);
  padding: 0.5rem 0.75rem;
  border: none;
  border-radius: 4px;

  color: var(--text);
  font-weight: 600;
  cursor: pointer;
}

.add:hover {
  background-color: var(--primary-hover);
}

.select-date {
  position: relative;
}

.calendar {
  position: absolute;
  top: 72%;
  left: -0.5%;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 380px;
  height: auto;
  padding: 0.5rem;
  background: var(--bg-light);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: inset 0 1px 0 var(--highlight), var(--shadow);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
}

.monthYear {
  width: 150px;
  text-align: center;
  font-weight: 600;
}

.header button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border);
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.day {
  text-align: center;
  padding: 0.25rem;
  color: var(--text-muted);
  font: 600;
}

.dates {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.25rem;
}

.date {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  padding: 0.5rem;
  border-radius: 50%;
  margin: auto;
  text-align: center;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}

.date:hover,
.date.active {
  background-color: var(--primary);
  color: var(--text);
}

.date.inactive {
  color: var(--border-muted);
}

.date.inactive:hover {
  color: #fff;
}

.hide {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB;wEACsE;AACxE;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,yCAAyC;;EAEzC,yBAAyB;EACzB,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,kCAAkC;EAClC,uBAAuB;EACvB,+BAA+B;;EAE/B,iEAAiE;EACjE,mEAAmE;EACnE,8EAA8E;;EAE9E,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;kCAEkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;;EAEd,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,sCAAsC;EACtC,kBAAkB;EAClB,yDAAyD;EACzD,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,YAAY;EACZ,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,yCAAyC;EACzC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;EAEnB,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;;EAElB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;;EAElB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  color: var(--text);\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n:root {\n  --primary: hsla(180, 45%, 34%, 0.9);\n  --primary-hover: hsla(180, 45%, 34%, 1);\n  --primary-light: hsla(180, 60%, 70%, 0.3);\n\n  --bg-dark: hsl(336 0% 1%);\n  --bg: hsl(300 0% 4%);\n  --bg-light: hsl(0 0% 9%);\n  --text: hsl(300 0% 95%);\n  --text-muted: hsl(300 0% 69%);\n  --highlight: hsla(330, 0%, 39%, 0.9);\n  --highlight-hover: hsl(330 0% 39%);\n  --border: hsl(0 0% 28%);\n  --border-muted: hsl(300 0% 18%);\n\n  --gradient: linear-gradient(0deg, var(--bg) 95%, var(--bg-light));\n  --gradient-hover: linear-gradient(0deg, var(--bg), var(--bg-light));\n  --shadow: 0px 2px 2px hsla(0, 0%, 0%, 0.07), 0px 4px 4px hsla(0, 0%, 0%, 0.15);\n\n  --secondary: hsl(358 66% 75%);\n  --danger: hsl(9 26% 64%);\n  --warning: hsl(52 19% 57%);\n  --success: hsl(146 17% 59%);\n  --info: hsl(217 28% 65%);\n}\n\nsvg {\n  width: 1.25rem;\n  height: 1.25rem;\n  fill: var(--text);\n}\n\nbody {\n  display: grid;\n  grid-template-columns: 270px 1fr;\n  grid-template-rows: auto 1fr;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bg-light);\n  transition: grid-template-columns 0.3s ease;\n}\n\nbody.collapsed {\n  grid-template-columns: 0 1fr;\n}\n\n#header {\n  grid-column: 1 / -1;\n  grid-row: 1;\n  display: flex;\n  align-items: center;\n  background-color: var(--primary);\n  padding: 1rem 2rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.sidebar-toggle {\n  width: 2rem;\n  height: 2rem;\n  padding: 0.25rem;\n  margin-right: 1rem;\n  border-radius: 4px;\n  stroke: var(--text) !important;\n}\n\n.sidebar-toggle:hover {\n  background-color: var(--primary-light);\n  cursor: pointer;\n}\n\n.header-inner {\n  width: 100%;\n}\n\n.sidebar {\n  grid-row: 2;\n  background-color: var(--bg-dark);\n  display: flex;\n  flex-direction: column;\n  gap: 5rem;\n  width: 270px;\n  min-width: 0;\n  padding: 1rem;\n  transition: transform 0.3s ease;\n}\n\n.sidebar.open {\n  transform: translateX(0%);\n}\n\n.sidebar.collapsed {\n  transform: translateX(-100%);\n}\n\n.sidebar-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar-item {\n  padding: 0.35rem 0.5rem;\n}\n\n.sidebar-item:hover {\n  background-color: var(--border-muted);\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.sidebar-item.active {\n  background-color: var(--primary-light);\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.sidebar-item--header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.project-item {\n  padding-right: 1.25rem;\n  padding-left: 2.15rem;\n  display: flex;\n  justify-content: space-between;\n}\n\n.project-details {\n  opacity: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.project-item:hover .project-details {\n  opacity: 1;\n}\n\n.project-item svg {\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 2px;\n  border-radius: 4px;\n}\n\n.project-item svg:hover {\n  fill: var(--border);\n  background-color: var(--text);\n}\n\n.project-item span {\n  width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.sidebar-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.sidebar-link--bar {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.sidebar-link--bar span {\n  white-space: nowrap;\n}\n\n.sidebar-link--bar svg {\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 2px;\n  border-radius: 4px;\n  opacity: 0;\n}\n\n.sidebar-link--bar:hover svg {\n  opacity: 1;\n}\n\n.sidebar-link--bar svg:hover {\n  fill: var(--border);\n  background-color: var(--text);\n}\n\n@media (max-width: 768px) {\n  body {\n    grid-template-columns: 0 1fr;\n  }\n\n  .sidebar {\n    transform: translateX(-100%);\n  }\n}\n\n.main-content {\n  grid-row: 2;\n  display: flex;\n  justify-content: center;\n  min-width: 0;\n  padding-top: 3rem;\n}\n\n/* .main-content centers, so to prevent view from shrinking before space around\n  collapses, set width 100% and make a max width. This protects the content until\n  all the surrounding space is 0 */\n.view {\n  width: 100%;\n  min-width: 0;\n  height: 100%;\n  max-width: 900px;\n  padding: 3rem;\n}\n\n.view-header {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  width: 100%;\n  min-width: 0;\n  background-color: transparent;\n  padding: 0;\n}\n\n.view-title {\n  max-width: 100%;\n  flex-shrink: 1;\n  margin: 0;\n  line-height: 1.2;\n  font-size: 2rem;\n  font-weight: 600;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.view-meta {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding-top: 0.5rem;\n  margin: 0;\n  font-size: 1rem;\n}\n\n.view-meta svg {\n  fill: var(--text-muted);\n}\n\n.view-meta-tasks {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0.5rem;\n}\n\n.view-meta-tasks > * {\n  margin: 0;\n  line-height: 1;\n\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.view-add-tasks:hover {\n  color: var(--text);\n  cursor: pointer;\n}\n\n.tasks-container {\n  width: 100%;\n  max-width: 900px;\n  padding-top: 2rem;\n}\n\n.task-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0.5rem;\n  border-bottom: 1px solid var(--highlight);\n  cursor: pointer;\n}\n\n.task-item:hover {\n  background-color: var(--border-muted);\n  transition: 0.3s ease;\n}\n\n.task-checkbox {\n  align-self: flex-start;\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0.25rem;\n  background-color: transparent;\n  border: 2px solid var(--text);\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.task-checkbox.complete {\n  background-color: green;\n}\n\n.task-item-right {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.task-text > * {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  padding-left: 1rem;\n}\n\n.task-title {\n  -webkit-line-clamp: 1;\n}\n\n.task-description {\n  color: var(--text-muted);\n  font-size: 0.8rem;\n}\n\n.task-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n@media (max-width: 425px) {\n  .task-details {\n    display: none;\n  }\n}\n\ndialog {\n  position: fixed;\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  max-width: 500px;\n  background: var(--gradient);\n  padding: 1rem;\n  margin: 0;\n  border: 1px solid var(--border);\n  border-top: 1px solid var(--highlight);\n  border-radius: 6px;\n  box-shadow: inset 0 1px 0 var(--highlight), var(--shadow);\n  z-index: 1;\n  overflow: visible;\n}\n\ndialog:hover {\n  background: var(--gradient);\n}\n\ndialog::backdrop {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.form-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: auto;\n}\n\n.form-container input {\n  background: transparent;\n  padding: 0.25rem 0.25rem 0.5rem 0.25rem;\n  border: none;\n  border-bottom: 1px solid var(--highlight);\n  outline: none;\n}\n\n.form-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.form-title::placeholder {\n  color: var(--text-muted);\n}\n\n.form-title.invalid {\n  border-bottom: 1px solid var(--secondary);\n}\n\n.error-box {\n  padding: 0.25rem;\n  color: var(--secondary);\n  font-size: 0.7rem;\n  opacity: 0;\n  transition: 0.2s ease;\n}\n\n.form-description {\n  padding-bottom: 0.35rem;\n  margin: 0.75rem 0 1.5rem 0;\n  border-bottom: 1px solid var(--highlight);\n  color: var(--text-muted);\n  font-size: 0.75rem;\n}\n\n.form-description::placeholder {\n  color: var(--text-muted);\n  font-size: 0.75rem;\n}\n\n.form-details {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.dropdown {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  position: relative;\n  cursor: pointer;\n}\n\n.dropdown-select {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 115px;\n  padding: 0.25rem 0.5rem;\n  background-color: var(--bg-light);\n  border: 1px solid var(--highlight);\n  border-radius: 4px;\n  font-size: 0.75rem;\n}\n\n.dropdown-select:hover {\n  background-color: var(--border-muted);\n  cursor: pointer;\n}\n\n.dropdown-list {\n  position: absolute;\n  top: 110%;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  background-color: var(--bg-light);\n  border: 1px solid var(--border-muted);\n  border-radius: 4px;\n  font-size: 0.75rem;\n}\n\n.dropdown-option {\n  width: 100%;\n  padding: 0.25rem 0.5rem;\n  text-align: center;\n}\n\n.dropdown-option:hover {\n  background-color: var(--border-muted);\n}\n\n.dropdown-option:first-child:hover {\n  border-radius: 3px 3px 0px 0px;\n}\n\n.dropdown-option:last-child:hover {\n  border-radius: 0px 0px 3px 3px;\n}\n\n.form-submit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 0.5rem;\n}\n\n.form-submit span {\n  padding: 0.25rem;\n  color: var(--secondary);\n  font-size: 0.75rem;\n}\n\n.form-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.cancel {\n  background-color: var(--highlight);\n  padding: 0.5rem 0.75rem;\n  border: none;\n  border-radius: 4px;\n\n  color: var(--text);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cancel:hover {\n  background-color: var(--highlight-hover);\n}\n\n.add {\n  background-color: var(--primary);\n  padding: 0.5rem 0.75rem;\n  border: none;\n  border-radius: 4px;\n\n  color: var(--text);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.add:hover {\n  background-color: var(--primary-hover);\n}\n\n.select-date {\n  position: relative;\n}\n\n.calendar {\n  position: absolute;\n  top: 72%;\n  left: -0.5%;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  width: 380px;\n  height: auto;\n  padding: 0.5rem;\n  background: var(--bg-light);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: inset 0 1px 0 var(--highlight), var(--shadow);\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem;\n}\n\n.monthYear {\n  width: 150px;\n  text-align: center;\n  font-weight: 600;\n}\n\n.header button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n  border: 1px solid var(--border);\n  border-radius: 50%;\n  background: transparent;\n  cursor: pointer;\n}\n\n.days {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n}\n\n.day {\n  text-align: center;\n  padding: 0.25rem;\n  color: var(--text-muted);\n  font: 600;\n}\n\n.dates {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 0.25rem;\n}\n\n.date {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  padding: 0.5rem;\n  border-radius: 50%;\n  margin: auto;\n  text-align: center;\n  font-weight: 600;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.date:hover,\n.date.active {\n  background-color: var(--primary);\n  color: var(--text);\n}\n\n.date.inactive {\n  color: var(--border-muted);\n}\n\n.date.inactive:hover {\n  color: #fff;\n}\n\n.hide {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
